var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmallZipZapIcon = function SvgSmallZipZapIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SmallZipZapIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E3553A",
    stroke: "#E3553A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.538,
    d: "m12.551 7.716-4.007 5.789c-.368.53-1.199.27-1.199-.375V9.315h-3.35a.658.658 0 0 1-.54-1.033l4.007-5.788c.367-.53 1.198-.271 1.198.374v3.816h3.35c.53 0 .843.596.541 1.032"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SmallZipZapIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSmallZipZapIcon;